import { useModals } from "src/components/Modals";

export const useImportProductImagesModal = () => {
  const { openModal } = useModals();

  const openImportProductImagesModal = () => openModal("ModalImportProductImages");

  return { openImportProductImagesModal };
};
